import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useChangePassword } from '../../../modules/auth/mutations';
import { DialogLayoutButton } from '../../../visual-components/dialog/dialog-layout-button';
import { Typography } from '../../../visual-components/typography/typography';
import { Dialog } from '../../../visual-components/dialog/dialog';
import { Button } from '../../../visual-components/button/button';
import { LinkButton } from '../../../visual-components/link/link';

type Props = {
  email: string;
};

export const ChangePasswordDialog: React.FC<Props> = ({ email }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const { mutateAsync: changePassword, isPending } = useChangePassword();
  const handleChangePassword = async () => {
    await changePassword(email);
    setIsOpen(false);
  };

  return (
    <Dialog
      isOpen={isOpen}
      title={t('profile.changePasswordDialog.title')}
      trigger={<LinkButton icon="arrow-circle">{t('profile.users.action.changePassword')}</LinkButton>}
      onOpenChange={setIsOpen}
    >
      <DialogLayoutButton
        buttons={
          <>
            <Button variant="secondary" onClick={() => setIsOpen(false)}>
              {t('global.no')}
            </Button>
            <Button disabled={isPending} onClick={() => handleChangePassword()}>
              {t('global.yes')}
            </Button>
          </>
        }
      >
        <Typography>{t('profile.changePasswordDialog.text')}</Typography>
      </DialogLayoutButton>
    </Dialog>
  );
};
